// extracted by mini-css-extract-plugin
export default {"extendedContainer":"styles_extendedContainer__6BMb-"};